<template>
	<div>
		<div class="right_one__title">
			<img :src="dataDetail.img" style="width: 250px;height: 150px;object-fit: cover;" alt="">
			<div class="showOne_title">
				<p style="font-size: 18px;">活动名称-{{dataDetail.name}}</p>
				<p>活动时间：{{dataDetail.time}}</p>
				<el-button type="primary" v-show="btnShow" @click="activeSubmit">活动报名</el-button>
			</div>
		</div>
		<!-- 手机模式 -->
		<div class="phoneMode">
			<div style="display: flex;justify-content: space-between;">
				<div class="phoneMode_title">
					<p>活动时间：{{dataDetail.time}}</p>
				</div>
				<el-button type="primary" v-show="btnShow"
					style="width: 75px;padding: unset;height: 30px;font-size: 12px;"
					@click="activeSubmit">活动报名</el-button>
			</div>
		</div>

		<div class="right_one__body">
			<p style="margin: 10px 0;font-size: 18px;font-weight: bold;text-align: center;">-会议简介-</p>
			<div class="contentDetail" v-html="dataDetail.description"></div>
		</div>

		<el-dialog title="活动报名" :visible.sync="dialogVisible" :width="activeWidth" :before-close="handleClose">
			<span>您好，为享受更完善的服务，请先注册/登录</span>
			<!-- <span>您好，会员报名参会请先登录；非会员报名参会仅限100个名额，先到先得。</span> -->
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="$router.push('/register')">点击注册个人会员</el-button> -->
				<el-button @click="navToLogin(false)"
					v-if="dataDetail.is_member == 2 ||dataDetail.is_member == 0">非个人会员登录入口</el-button>
				<el-button type="primary" v-if="dataDetail.is_member == 1||dataDetail.is_member == 0"
					style="background-color: #c22c25;border: none;" @click="navToLogin(true)">
					个人会员登录入口
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		checkTimeApi
	} from '@/api/moudles/activities.js'
	export default {
		data() {
			return {
				dialogVisible: false,
				activeWidth: '30%',
				dataDetail: {},
				btnShow: true
			}
		},
		mounted() {
			if (this.$phoneSize()) {
				this.activeWidth = '98%'
			} else {
				this.activeWidth = '30%'
			}
		},
		methods: {
			// 设置内容
			setContent(params) {
				this.dataDetail = params
				if (this.$route.params.status) {
					this.activeSubmit()
				}
				const checkUser = this.$store.state.user.userVip
				if (checkUser === true || checkUser === false) {
					if (checkUser && (this.dataDetail.is_member == 1 || this.dataDetail
							.is_member == 0)) {
						// 会员报名
					} else if (checkUser == false && (this.dataDetail.is_member ==
							2 || this.dataDetail.is_member == 0)) {
						// 非会员报名
					} else {
						this.btnShow = false
					}
				}
			},
			//会员登录入口
			navToLogin(bool) {
				this.dialogVisible = false
				const screenWidth = window.screen.width;
				if (screenWidth < 760) {
					this.$router.push({
						name: 'phoneLogin',
						params: {
							isMember: bool,
							meetingCode: this.dataDetail.meeting_code
						}
					})
				} else {
					this.$router.push({
						name: 'login',
						params: {
							isMember: bool,
							meetingCode: this.dataDetail.meeting_code
						}
					})
				}
			},
			// 确认报名
			applyMeeting() {
				this.dialogVisible = false
				this.$emit('submit', false)
			},
			// /点击报名
			activeSubmit() {
				checkTimeApi({
					data: {
						rule_code: this.dataDetail.rule_code
					},
					success: res => {
						if (res.code !== '200') {
							this.$message.error(res.msg)
						} else {
							// 判断是否在报名时间内
							// 判断有无登录
							if (this.$store.state.user.token) {
								this.applyMeeting()
							} else {
								this.dialogVisible = true
							}
						}
					}
				})
			},
			handleClose() {
				this.dialogVisible = false
			}
		}
	}
</script>

<style scoped>
	>>>.contentDetail img,
	.contentDetail p>img,
	.contentDetail span>img {
		max-width: 100%;
	}

	@media screen and (max-width: 750px) {
		.right_one__title {
			display: none;
		}

		.phoneMode_title {
			font-size: 14px;
		}
	}

	@media screen and (min-width: 750px) {
		.phoneMode {
			display: none;
		}

		.right_one__title {
			border-bottom: 1px solid #bbb;
			min-height: 150px;
			display: flex;
			padding-bottom: 20px;
		}
	}

	>>>.el-dialog__footer {
		text-align: center;
	}

	.showOne_title {
		padding: 0 20px;
	}

	.showOne_title p {
		margin-bottom: 10px;
	}

	.showOne_title button {
		margin-top: 45px;
	}
</style>